import { useQuery, useQueryCache } from 'react-query';
import React, { useCallback, useState } from 'react';
import { QueryKey } from 'api/queryKey';
import Column from 'antd/lib/table/Column';
import { Layout, PageHeader, Space } from 'antd';
import { UsersAPI } from 'api/UsersAPI';
import { PatientStatusTag } from 'common/components/PatientStatusTag';
import { DeletePatientButton } from 'pages/SuperAdminModule/PatientsPage/DeletePatientButton';
import {
  Patient,
  patientsInitialPageParams,
  PatientStatus,
} from 'models/patient';
import { Content } from 'common/StyledComponents';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { NumberedTable } from 'common/components/NumberedTable';
import { toSimpleDate } from 'common/dateFnsUtils';
import { commonPaginationConfig } from 'models/page';
import { CloseOutlined } from '@ant-design/icons/lib';

export const PatientsPage = () => {
  const queryCache = useQueryCache();

  const [pageMetaData, setPageMetaData] = useState(patientsInitialPageParams);

  const { isFetching, data } = useQuery(
    [QueryKey.Patients, pageMetaData],
    () => UsersAPI.fetchPatients(pageMetaData),
    {
      keepPreviousData: true,
    }
  );

  const paginationConfig = {
    ...commonPaginationConfig,
    current: pageMetaData?.page,
    pageSize: data?.size,
    total: data?.totalElements,
    onChange: (page: number, pageSize?: number) =>
      setPageMetaData((prev) => ({
        ...prev,
        page,
        ...(pageSize && { pageSize }),
      })),
  };

  const invalidatePatients = useCallback(
    () => queryCache.invalidateQueries(QueryKey.Patients).then(),
    [queryCache]
  );

  const intlMessage = useFormatMessage();

  return (
    <Layout>
      <Content>
        <PageHeader title={intlMessage({ id: 'patients' })} />
        <NumberedTable
          rowKey="id"
          loading={isFetching}
          dataSource={data?.content}
          pagination={paginationConfig}
          scroll={{ x: 'auto' }}
        >
          <Column
            title={intlMessage({ id: 'name' })}
            dataIndex="firstName"
            width={'40%'}
            render={
              (value, record: Patient) =>
                // <Link
                //   key={`${url}/${record.userId}`}
                //   to={`${url}/${record.userId}`}
                // >
                `${record.firstName} ${record.lastName}`
              // </Link>
            }
          />
          <Column
            title={intlMessage({ id: 'create_date' })}
            dataIndex="createDate"
            render={(value) => toSimpleDate(value)}
          />
          <Column
            title={intlMessage({ id: 'partner' })}
            dataIndex={['partnerDetails', 'name']}
            align="center"
            render={(value) => value || <CloseOutlined />}
          />
          <Column
            title={intlMessage({ id: 'status' })}
            dataIndex="patientStatus"
            render={(value) => <PatientStatusTag status={value} />}
          />

          <Column
            title={intlMessage({ id: 'actions' })}
            key="actions"
            align="right"
            render={(value, record: Patient) => (
              <Space direction={'vertical'} style={{ width: '150px' }}>
                {record.patientStatus !== PatientStatus.Archived && (
                  <DeletePatientButton
                    danger
                    patient={record}
                    onDeleted={invalidatePatients}
                  />
                )}
              </Space>
            )}
          />
        </NumberedTable>
      </Content>
    </Layout>
  );
};
